module.exports = __webpack_public_path__ + "static/media/IQ_Content_Image.3c16e59b.png";